import { useCallback } from "react"

interface Validate {
  key: string
  value: string
  setHint: (arg1: string) => any
  isNum?: boolean
}

export function useValidate(arr: Validate[]) {
  return useCallback(() => {
    for (const v of arr) {
      if (!v.value) {
        v.setHint(`请输入${v.key}`)
        return false
      }
      if (v.isNum && isNaN(Number(v.value))) {
        v.setHint(`${v.key}必须为数字`)
        return false
      }
    }
    return true
  }, [arr])
}
